import { HTMLAttributes } from 'react';

import { ProfileMenu } from '../../molecules/profileMenu/profileMenu';
import { ProfileMenuItemProps } from '../../atoms/profileMenuItem/profileMenuItem';
import { twMerge } from 'tailwind-merge';

type Props = {
  notificationCount: number;
  avatar: {
    initials: string;
    src: string;
    alt: string;
  };
  name: string;
  menuItems: Array<ProfileMenuItemProps>;
} & HTMLAttributes<HTMLDivElement>;

export function Toolbar(props: Props) {
  const { notificationCount, avatar, name, menuItems, className, ...rest } =
    props;

  return (
    <div
      className={twMerge(
        'flex items-center justify-end py-16 border-b border-b-grayscale100 px-32 bg-grayscale0 z-10',
        className,
      )}
      {...rest}
    >
      <div className="space-x-32 flex items-center">
        {/* <NotificationButton notificationCount={0} isDisabled /> */}
        <ProfileMenu avatar={avatar} name={name} menuItems={menuItems} />
      </div>
    </div>
  );
}
